import styled, { css } from 'styled-components';
import { SEARCH_INPUT_FONT_SIZE } from 'view/search-modal/search-bar/styled';
import * as elevation from 'view/styles/elevation';
import * as grid from 'view/styles/grid';
import * as mixins from 'view/styles/mixins';
import * as transitions from 'view/styles/transitions';
import { searchTextbox, searchTextboxBackground } from 'view/styles/z-index';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { UnstyledButton } from '@atlassian/help-center-common-component/unstyled-button';

const borderRadius = css`
    border-radius: 5px;
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const Input = styled.input`
    ${SEARCH_INPUT_FONT_SIZE};
    ${borderRadius};
    ${mixins.placeholder(token('color.text.subtlest', colors.N200))};
    padding: ${grid.multiple(2.125).px};
    padding-right: ${token('space.400', '32px')};
    width: 100%;
    border: 0;
    outline: none;
    position: relative;
    z-index: ${searchTextbox};
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const InputBackground = styled.div`
    ${borderRadius};
    background-color: ${token('color.background.input', colors.N0)};
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transition: box-shadow ${transitions.speedMs.slow}ms ${transitions.timingFunctions.easeInOut};
    z-index: ${searchTextboxBackground};

    /* box shadow should apply to the background element so it animates properly,
       but should only apply on hover or focus on the sibling input element */
    ${/* sc-selector */ Input}:hover + &,
    ${/* sc-selector */ Input}:focus + & {
        ${elevation.e300};
        z-index: ${searchTextboxBackground};
    }
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const IconButton = styled(UnstyledButton)`
    position: absolute;
    padding: 0 ${token('space.200', '16px')};
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    border-radius: 0 ${mixins.borderRadiusValue} ${mixins.borderRadiusValue} 0;
    cursor: pointer;
    z-index: ${searchTextbox};

    &:hover {
        > span {
            ${transitions.zoom()};
        }
    }
`;
